module.exports = __webpack_public_path__ + "public/img/weibo.72e38a35.png";